import { Injectable } from "@angular/core";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { TipoOcorrencia } from '@tivic-team/manager-ts/dist/grl/entities/tipo-ocorrencia.entity';
import { HttpGet, HttpPost, HttpPut, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { HttpResponse } from "sol-request-angular/dist/comunicacao";
import { environment } from "src/environments/environment";

@Injectable()
export class TipoOcorrenciaController {

    constructor() { }

    async find( filtros?:IFilter ):Promise< Array< TipoOcorrencia > >{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/tipoOcorrencia',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array< TipoOcorrencia >()
			)
		);
		return await quark.call();
	}

    async get( cdTipoOcorrencia:number):Promise< TipoOcorrencia >{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/tipoOcorrencia/:cdTipoOcorrencia',
					environment: environment,
					pathParams: new JSONData({ cdTipoOcorrencia:  cdTipoOcorrencia })
				}),
			}),
			new HttpResponse(
				new TipoOcorrencia()
			)
        );
        return await quark.call();
	}

    async create( tipoOcorrencia: TipoOcorrencia ):Promise< TipoOcorrencia > {
        let quark= new Quark( 
            new HttpPost( {
                url: new Url( {
                    id: 'grl/tipoOcorrencia',
                    environment: environment
                }),
                data: new JSONData( tipoOcorrencia )
            }),
            new HttpResponse( 
                new TipoOcorrencia()
            )
        );
        return await quark.call();
    }

    async update( tipoOcorrencia: TipoOcorrencia ):Promise< TipoOcorrencia > {
        let quark = new Quark(
            new HttpPut( {
                url: new Url( {
                    id: 'grl/tipoOcorrencia/:cdTipoOcorrencia',
                    environment: environment,
                    pathParams: new JSONData( { cdTipoOcorrencia: tipoOcorrencia.cdTipoOcorrencia } )
                }),
                data: new JSONData( tipoOcorrencia )
            }),
            new HttpResponse(
                new TipoOcorrencia()
            )
        )
        return await quark.call();
    }
}